import { createApp } from "vue";
import { createPinia } from "pinia";
import { createRouter, createWebHashHistory } from "vue-router";
import App from "./ui/App.vue";
import { routes } from "./routes";
import { useToastStore } from "./stores/toast";
import { ApiRequestError, type ApiErrorEventDetail } from "./api/client";
import "./styles.css";

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

const pinia = createPinia();
const app = createApp(App).use(pinia).use(router);

window.addEventListener("qqpb:api-error", (event) => {
  const detail = (event as CustomEvent<ApiErrorEventDetail>).detail;
  useToastStore().push(detail?.message || "请求失败", "error", {
    code: detail?.code,
    status: detail?.status
  });
});
window.addEventListener("unhandledrejection", (event) => {
  if (event.reason instanceof ApiRequestError) return;
  const message = event.reason instanceof Error ? event.reason.message : "操作失败";
  useToastStore().push(message, "error");
});

app.mount("#app");
